<template>
  <!--
      作者 gmshop
      时间：2020-06-09
      描述：会员-等级管理-编辑等级
  -->
  <el-dialog title="编辑等级" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false" width="1000px">
    <el-form size="small" :model="form" ref="form">
      <el-form-item label="等级名称" :label-width="formLabelWidth" prop="name" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="等级权重" :label-width="formLabelWidth" prop="weight" :rules="[{required: true,message: '请输入等级权重'}]">
        <el-input v-model="form.weight" type="number" placeholder="请输入等级权重"></el-input>
        <div class="gray9">权重越大，等级越高,不同等级请设置权重不一样，否则会影响用户升级</div>
      </el-form-item>
      <el-form-item label="选择级别" :label-width="formLabelWidth" >
        <el-select v-model="form.level" >
          <el-option v-for="(item,index) in levelList" :key="index" :label="item.name" :value="item.level"></el-option>
        </el-select>
        <div  v-auth="'/plus/agent/belongmode'" class="gray9">成为1级别以上用户，才具备用户归属权限，获得见单奖励，低级别请选择无</div>
      </el-form-item>
      <el-form-item label="等级折扣" :label-width="formLabelWidth" prop="equity" :rules="[{required: true,message: '请输入等级折扣'}]">
        <el-input type="number" :precision="1" :step="1" :min="0" :max="100" placeholder="请输入等级折扣" v-model="form.equity">
            <template slot="append">%</template>
        </el-input>
      </el-form-item>
      <el-form-item label="是否参与满减活动"  :label-width="formLabelWidth" v-auth="'/plus/fullreduce/index'">
        <div>
          <el-radio v-model="form.no_full_reduce" :label="0">参与</el-radio>
          <el-radio v-model="form.no_full_reduce" :label="1">不参与</el-radio>
          <div class="tips">选择不参与，用户将不能参加满减 优惠</div>
        </div>
      </el-form-item>
      <!-- <el-form-item label="会员有效期" :label-width="formLabelWidth" prop="name" :rules="[{required: true,message: '请输入会员有效期'}]">
        <el-input type="number" :precision="1" :step="1" :min="0" placeholder="请输入会员有效期" v-model="form.expiry_date">
          <template slot="append">天</template>
          </el-input>
          <div class="gray9">为0则没有有效期</div>
      </el-form-item> -->
      <el-form-item label="升级条件" :label-width="formLabelWidth" v-if="form.is_default==0">
        <div class="gray9">满足以下勾选的其中一个条件，会员自动升级到该等级</div>
        <div class="d-s-c mt16">
          <el-checkbox v-model="form.open_money">累计消费满</el-checkbox>
          <el-input v-model="form.upgrade_money" type="number"  min="0"  :disabled="form.open_money==0" style="width: 160px; margin-left: 10px;" ></el-input>
          <span class="ml10">元</span>
        </div>
        <!-- <div class="d-s-c mt16">
          <el-checkbox v-model="form.open_disposable_upgrade">一次性消费满</el-checkbox>
          <el-input v-model="form.upgrade_disposable_money"  min="0"  type="number" :disabled="form.open_disposable_upgrade==0" style="width: 160px; margin-left: 10px;" ></el-input>
          <span class="ml10">元</span>
        </div> -->
        <div class="d-s-c mt16">
          <el-checkbox v-model="form.open_points">累计积分满</el-checkbox>
          <el-input v-model="form.upgrade_points" type="number"   min="0"  :disabled="form.open_points==0" style="width: 160px;margin-left: 10px;"></el-input>
          <span class="ml10">个</span>
        </div>
        <!-- <div class="d-s-c mt16">
          <el-checkbox v-model="form.open_invite">推荐人数满</el-checkbox>
          <el-input v-model="form.upgrade_invite" type="number"  min="0"  :disabled="form.open_invite==0" style="width: 160px;margin-left: 10px;"></el-input>
          <span class="ml10">人</span>
        </div> -->
        <div class="d-s-c mt16">
          <el-checkbox v-model="form.open_grade">直推等级</el-checkbox>
          <el-select v-model="form.down_grade_id" class="ml10" clearable>
            <el-option v-for="(item,index) in grade_list" :key="index" :label="item.name" :value="item.grade_id"></el-option>
          </el-select>
          <span class="ml10">满</span>
          <el-input v-model="form.upgrade_total" type="number" :disabled="form.open_grade==0" style="width: 160px;margin-left: 10px;"></el-input>
           <span class="ml10">人</span>
        </div>
         <div class="d-s-c mt16">
          <!-- <span class="ml10"> 或者</span>
            <el-select v-model="form.to_grade_id" class="ml10" clearable>
              <el-option v-for="(item,index) in grade_list" :key="index" :label="item.name" :value="item.grade_id"></el-option>
            </el-select> -->
          <!-- <el-input v-model="form.team_users" type="number"  min="0"  :disabled="form.open_grade==0" style="width: 160px;margin-left: 10px;"></el-input>
          <span class="ml10">人 且</span> -->
          <!-- <span class="ml10">团队</span> -->
            <!-- <el-input v-model="form.team_goods" type="number"  min="0"  :disabled="form.open_grade==0" style="width: 160px;margin-left: 10px;"></el-input>
          <span class="ml10">单,升级到该等级</span> -->
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="editGrade" :disabled="submit_loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import UserApi from '@/api/user.js';
  export default {
    data() {
      return {
        //代理级别
        levelList: [
          {
            name:'无',
            level: 0,
          },
          {
            name:'1级',
            level: 1,
          },
          {
            name:'2级',
            level: 2,
          },
          {
            name:'3级',
            level: 3,
          },
          {
            name:'4级',
            level: 4,
          },
          {
            name:'5级',
            level: 5,
          },
          {
            name:'6级',
            level: 6,
          },
          {
            name:'7级',
            level: 7,
          },
          {
            name:'8级',
            level: 8,
          },
          {
            name:'9级',
            level: 9,
          },
          {
            name:'10级',
            level: 10,
          }
        ],
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        /*是否正在提交*/
        submit_loading: false,
      };
    },
    props: ['open_edit', 'form','grade_list'],
    created() {
      this.form.open_money=this.form.open_money==1?true:false;
      this.form.open_points=this.form.open_points==1?true:false;
      this.form.open_invite=this.form.open_invite==1?true:false;
      this.form.open_grade=this.form.open_grade==1?true:false;
      this.form.open_disposable_upgrade=this.form.open_disposable_upgrade==1?true:false;
      this.dialogVisible = this.open_edit;
    },
    methods: {
      /*修改用户*/
      editGrade() {
        let self = this;
        let params = this.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.submit_loading = true;
            if(params.is_default==0){
              params.open_money=params.open_money==true?1:0;
              params.open_points=params.open_points==true?1:0;
              params.open_invite=params.open_invite==true?1:0;
              params.open_grade=params.open_grade==true?1:0;
              params.open_disposable_upgrade=params.open_disposable_upgrade==true?1:0;
            }else{
              delete params.open_money;
              delete params.open_points;
              delete params.open_invite;
              delete params.upgrade_money;
              delete params.upgrade_points;
              delete params.upgrade_invite;
              delete params.open_grade;
              delete params.down_grade_id;
              delete params.team_grade_id;
              delete params.to_grade_id;
              delete params.upgrade_total;
              delete params.team_goods;
              delete params.team_users;
              delete params.open_disposable_upgrade;
              delete params.upgrade_disposable_money;
            }
            UserApi.editGrade(params, true)
              .then(data => {
                self.submit_loading = false;
                self.$message({
                  message: '恭喜你，等级修改成功',
                  type: 'success'
                });
                self.dialogFormVisible(true);

              })
              .catch(error => {
                self.submit_loading = false;
              });

          }
        });
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      }

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/user/grade/Edit.vue